export const ERROR_MESSAGES = {
    // 認証関連
    AUTH: {
        LOGIN_FAILED: 'ログインに失敗しました。メールアドレスとパスワードを確認してください。',
        REGISTER_FAILED: '登録に失敗しました。入力内容を確認してください。',
        UNAUTHORIZED: '認証が必要です。再度ログインしてください。',
        TOKEN_EXPIRED: 'セッションが切れました。再度ログインしてください。',
        FIREBASE_AUTH_FAILED: 'ログインに失敗しました。メールアドレスとパスワードをご確認ください。',
        TOKEN_FETCH_FAILED: '認証トークンの取得に失敗しました',
        USER_CREATE_FAILED: 'ユーザー登録に失敗しました',
        DISPOSABLE_EMAIL: '捨てアドレスでの登録はできません。正規のメールアドレスを使用してください。',
    },
    // Firebaseエラーコード
    FIREBASE: {
        'auth/email-already-in-use': 'このメールアドレスは既に使用されています',
        'auth/invalid-email': '無効なメールアドレスです',
        'auth/operation-not-allowed': 'この操作は許可されていません',
        'auth/weak-password': 'パスワードが脆弱です。より強力なパスワードを設定してください',
        'auth/user-disabled': 'このアカウントは無効化されています',
        'auth/user-not-found': 'メールアドレスまたはパスワードが間違っています',
        'auth/wrong-password': 'メールアドレスまたはパスワードが間違っています',
        'auth/invalid-credential': 'メールアドレスまたはパスワードが間違っています',
        'auth/invalid-login-credentials': 'メールアドレスまたはパスワードが間違っています',
        'auth/too-many-requests': '試行回数が多すぎます。しばらく時間をおいてから再度お試しください',
        'auth/network-request-failed': 'ネットワークエラーが発生しました。インターネット接続をご確認ください',
        'auth/popup-closed-by-user': '認証ポップアップが閉じられました',
        'auth/requires-recent-login': '再度ログインが必要です',
        'auth/user-token-expired': 'セッションの有効期限が切れました。再度ログインしてください',
        'auth/account-exists-with-different-credential': '別の認証方法で既に登録されているアカウントです',
        'auth/credential-already-in-use': 'この認証情報は既に使用されています',
        'auth/timeout': '認証がタイムアウトしました。再度お試しください',
        'auth/cancelled-popup-request': '認証がキャンセルされました',
        'auth/popup-blocked': 'ポップアップがブロックされました。ブラウザの設定をご確認ください'
    },
    // 物件関連
    ROOM: {
        CREATE_FAILED: '物件の登録に失敗しました。',
        UPDATE_FAILED: '物件の更新に失敗しました。',
        DELETE_FAILED: '物件の削除に失敗しました。',
        NOT_FOUND: '物件が見つかりませんでした。',
    },
    // プロフィール関連
    PROFILE: {
        UPDATE_FAILED: 'プロフィールの更新に失敗しました。',
        INVALID_DATA: '入力内容に誤りがあります。',
    },
    // API関連
    API: {
        NETWORK_ERROR: 'ネットワークエラーが発生しました。',
        SERVER_ERROR: 'サーバーエラーが発生しました。',
        TIMEOUT: '接続がタイムアウトしました。',
    },
    MESSAGE: {
        SEND_FAILED: 'メッセージの送信に失敗しました',
        LOAD_FAILED: 'メッセージの読み込みに失敗しました',
    },
    FAVORITE: {
        UPDATE_FAILED: 'お気に入りの更新に失敗しました',
        LOAD_FAILED: 'お気に入りの読み込みに失敗しました',
    },
    SEARCH: {
        FAILED: '検索中にエラーが発生しました',
        NO_RESULTS: '条件に一致する物件が見つかりませんでした',
    },
    RESERVATION: {
        CREATE_FAILED: '予約の作成に失敗しました',
        UPDATE_FAILED: '予約の更新に失敗しました',
        CANCEL_FAILED: '予約のキャンセルに失敗しました',
    },
    IMAGE: {
        UPLOAD_FAILED: '画像のアップロードに失敗しました',
        DELETE_FAILED: '画像の削除に失敗しました',
    },
    CHAT: {
        INITIATE_FAILED: 'チャットの開始に失敗しました',
        SEND_FAILED: 'メッセージの送信に失敗しました',
    },
    VALIDATION: {
        REQUIRED: '必須項目です',
        EMAIL: '有効なメールアドレスを入力してください',
        PASSWORD: {
            MIN_LENGTH: 'パスワードは8文字以上で入力してください',
            MATCH: 'パスワードが一致しません',
            REQUIREMENTS: '英字、数字を含む8文字以上で入力してください'
        },
        PROFILE: {
            NICKNAME: '2文字以上20文字以内で入力してください',
            INTRODUCTION: '1000文字以内で入力してください',
            AGE: '有効な生年月日を入力してください',
            OCCUPATION: '20文字以内で入力してください'
        },
        ROOM: {
            RENT: '有効な金額を入力してください',
            IMAGES: {
                MAX_COUNT: '画像は最大5枚までアップロードできます',
                SIZE: '画像サイズは5MB以下にしてください',
                FORMAT: '対応している画像形式: JPG, PNG, GIF',
                MIN_COUNT: '最低1枚の画像をアップロードしてください',
            },
            DESCRIPTION: '1000文字以内で入力してください'
        }
    },
    UPLOAD: {
        FAILED: 'アップロードに失敗しました。再度お試しください',
        NETWORK_ERROR: 'ネットワークエラーが発生しました',
        INVALID_TYPE: '対応していないファイル形式です'
    },
    SEARCH: {
        NO_RESULTS: '検索条件に一致する結果が見つかりませんでした',
        ERROR: '検索中にエラーが発生しました。再度お試しください',
        INVALID_QUERY: '検索条件が無効です'
    },
    FORM: {
        SUBMIT_ERROR: '送信に失敗しました。再度お試しください。',
        FIREBASE_USER_DELETE_SUCCESS: 'Firebaseユーザーの削除に成功しました',
        FIREBASE_USER_DELETE_ERROR: 'Firebaseユーザーの削除に失敗しました'
    }
};

export const getFirebaseErrorMessage = (error) => {
    // Firebaseエラーコードがある場合
    if (error?.code && ERROR_MESSAGES.FIREBASE[error.code]) {
        return ERROR_MESSAGES.FIREBASE[error.code];
    }

    // エラーメッセージから推測できる場合
    if (error?.message) {
        const message = error.message.toLowerCase();

        // ネットワーク関連のエラー
        if (message.includes('network') || message.includes('fetch')) {
            return 'ネットワークエラーが発生しました。インターネット接続をご確認ください';
        }

        // タイムアウト関連のエラー
        if (message.includes('timeout')) {
            return '接続がタイムアウトしました。再度お試しください';
        }

        // 認証情報関連のエラー
        if (message.includes('credential') || message.includes('password') || message.includes('email')) {
            return 'メールアドレスまたはパスワードが間違っています';
        }
    }

    // デフォルトのメッセージ
    return ERROR_MESSAGES.AUTH.FIREBASE_AUTH_FAILED;
}; 